import React from 'react';

const Badge = ({ className }) => (
  <span className="bs-badge">
    <sup data-show="true" className={className} />
  </span>
);

export default Badge;
